import { get, has, flatten, fromPairs, head, last, sortBy } from 'lodash-es'
import { TYPE_TO_GROUP } from '@/js/helper/filter-constants.js'
import { filter } from '@/js/helper/settings-filter.js'
import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'

export const generateCodeToIdAttributeMap = data => {
  const attributeArray = flatten(Object.values(data))
  return attributeArray.reduce((map, attr) => {
    map.set(getTypeCodeId(attr.type, attr.code), attr.id)
    return map
  }, new Map())
}

// console.log({ TYPE_TO_GROUP })

export const getSettingsType = type => (TYPE_TO_GROUP.has(type) ? TYPE_TO_GROUP.get(type) : type)

export const getTypeCodeId = (type, code) => {
  const finalType = getSettingsType(type)
  // console.log(`${finalType}.${code}`)
  return `${finalType}.${code}`
}

export const getItemSettings = (type, scope) => {
  const scopeSetting = get(filter, ['config', 'scope', scope, 'items', type])
  const setting = get(filter, ['config', 'items', type])
  const groupType = getSettingsType(type)
  const groupScopeSetting = groupType
    ? get(filter, ['config', 'scope', scope, 'items', groupType])
    : undefined
  const groupSetting = groupType
    ? groupScopeSetting
      ? groupScopeSetting
      : get(filter, ['config', 'items', groupType])
    : undefined
  // console.log('getItemSettings', {
  //   scope,
  //   type,
  //   groupSetting,
  //   scopeSetting,
  //   setting,
  //   resultingSetting: groupSetting
  //     ? groupSetting
  //     : scopeSetting
  //     ? scopeSetting
  //     : setting
  //     ? setting
  //     : {},
  // })
  return groupSetting ? groupSetting : scopeSetting ? scopeSetting : setting ? setting : {}
}

export const generateAttributeDataWithConfig = (data, scope) => {
  // console.log('generateAttributeDataWithConfig')
  const attributeArray = Array.isArray(data) ? data : [data]
  const attributes = attributeArray.reduce(
    (attributes, attr) => {
      const type = get(attr, 'type')
      if (!has(attributes, type)) {
        attributes[type] = []
      }
      attributes[type].push(attr)
      return attributes
    },
    {
      SearchText: [
        { code: 'SearchText', id: 'SearchText', label: 'SearchText', type: 'SearchText' },
      ],
    },
  )

  // console.log(attributes)

  const attributesWithSettings = Object.entries(attributes).map(([type, values]) => {
    const itemSettings = getItemSettings(type, scope)
    // console.log(itemSettings)
    // console.log(values.map(value => ({ ...value, ...get(itemSettings, value.code, {}) })))
    const processedValues = values.map(value =>
      has(filterTypeFunctions, type)
        ? filterTypeFunctions[type]({ ...value, ...get(itemSettings, value.code, {}) })
        : { ...value, ...get(itemSettings, value.code, {}) },
    )
    return [
      type,
      has(groupTypeFunctions, type) ? groupTypeFunctions[type](processedValues) : processedValues,
    ]
  })
  // console.log(fromPairs(attributesWithSettings))
  return fromPairs(attributesWithSettings)
}

const filterDataFunctions = {
  // Category: item => {
  //   console.log(item)
  //   const codes = (item?.code || '').split('|')
  //   console.log(codes)
  //   return {
  //     ...item,
  //   }
  // },
  ItemBrand: item => {
    const brand = get(filter, ['items', 'ItemBrand', 'brand', item.code])
    return {
      ...item,
      brand: brand ? brand.split(',') : [],
      sort: get(filter, ['items', 'ItemBrand', 'sort', item.code]),
    }
  },
  SearchPrice: (item, values = []) => {
    return {
      ...item,
      id: values.length ? values.join('|') : 'SearchPrice',
      values: values.map((i, index) => {
        return {
          code: `SearchPrice${index}`,
          id: i,
          title: `${i}`,
          type: 'SearchPrice',
        }
      }),
    }
  },
  SearchText: (item, values) => {
    // console.log('filterDataFunctions - SearchText', item, values)
    return {
      code: 'SearchText',
      id: values?.[0],
      title: values?.[0],
      type: 'SearchText',
    }
  },
  ItemGenderFrame: item => {
    return {
      ...item,
      icon: get(BIKE_ATTRIBUTES.FILTER_ICONS, [BIKE_ATTRIBUTES.TYPE.ITEM_FRAME_TYPE, item.code]),
    }
  },
  ItemFrameType: item => {
    return {
      ...item,
      icon: get(BIKE_ATTRIBUTES.FILTER_ICONS, [BIKE_ATTRIBUTES.TYPE.ITEM_FRAME_TYPE, item.code]),
    }
  },
}

const GroupedItems = items => {
  // const settings = isEmpty(this.itemsSettings)
  //   ? this.cacheGetItemSettings(key)
  //   : this.itemsSettings // this.itemsSettings is not available in Summary
  const grouped = Object.values(
    items.reduce((result, item) => {
      const group = item.group || item.code
      // const group = get(settings, [item.code, 'group'], item.code)

      if (!has(result, group)) {
        result[group] = {
          code: group,
          group,
          type: item.type,
          id: [],
          items: [],
        }
      }

      result[group].id.push(item.id)
      result[group].items.push(item)

      return result
    }, {}),
  ).map(item => {
    if (!Array.isArray(item.id)) {
      return item
    }
    return generateGroupData(item)
  })
  return sortItemsBy(grouped, '', () => o => get(o, ['items', 0, 'code'], get(o, 'code')))
}

const generateGroupData = g => {
  // const title = this.getGroupTitle(g) || g.items.map(i => i.title).join(', ')
  const id = g.items.map(i => i.id)
  const items = sortItemsBy(g.items)
  const count = g.items.reduce((count, i) => count + (parseInt(i.count, 10) || 0), 0)

  return {
    ...g,
    count,
    groupId: g.id.join('|'),
    // title: `${title} (${currentCount})`,
    id,
    items,
  }
}

const groupTypeFunctions = {
  ItemWheelSizeInch: GroupedItems,
  ProductBidexCommodityGroup: GroupedItems,
  ItemBatteryWattHours: items => {
    const sortedItems = sortItemsBy(items)
    const count = sortedItems.length
    const codes = sortedItems.map(i => i.code)
    const ids = sortedItems.map(i => i.id)
    return [
      {
        code: 'ItemBatteryWattHours',
        codes,
        groupId: ids.join('|'),
        type: 'ItemBatteryWattHours',
        title: `${head(codes)}–${last(codes)} (${count})`,
        id: ids,
        items: sortedItems,
      },
    ]
  },
  ItemSupplier: items => {
    const hasItemsWithShowSetting = items.some(item => has(item, 'show'))
    return hasItemsWithShowSetting ? items.filter(item => !!item.show) : items
  },
  ProductSeason: items => {
    return sortItemsBy(items)
  },
}

const filterTypeFunctions = {
  ...filterDataFunctions,
  ItemBrandArchiv: filterDataFunctions.ItemBrand,
  PartBrand: filterDataFunctions.ItemBrand,
}

const sortItemsBy = (items, prop = 'code', compareFn = prop => o => get(o, prop)) => {
  return sortBy(items, compareFn(prop))
}
